import React, { useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { GlobalContext } from "../../../../global/context/Provider";
import { multiTabDataMisMedicos } from "../../../../global/utils/multiTabData";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import { showModal } from "../../../context/Actions/modal/modal";
import camelize from "../../../../global/utils/camelize";
import { IoChevronDown, IoFilterOutline } from "react-icons/io5";
import "./MultitabMobileMisMedicos.css";

const MultitabMobileMisMedicos = ({
  onChangeFiltro,
  onChangePaciente,
  datosFamiliares,
  userSelect,
  especialistas,
}) => {
  const { modalDispatch, selectDropDownState } = useContext(PortalContext);
  const { authState } = useContext(GlobalContext);

  const handleOpenModalFamiliares = () => {
    showModal(
      "Genericos/ModalSeleccionarFamiliar/ModalSeleccionarFamiliar",
      {
        familiares: datosFamiliares,
        onSelectFamiliar: onChangePaciente,
      },
      [],
      "bottomSheet",
      false,
    )(modalDispatch);
  };

  const handleOpenModalFiltro = () => {
    showModal(
      "Genericos/ModalSeleccionarFiltro/ModalSeleccionarFiltro",
      {
        filtros: multiTabDataMisMedicos,
        onSelectFiltro: onChangeFiltro,
        filtroActual: especialistas,
      },
      [],
      "bottomSheet",
      false,
    )(modalDispatch);
  };

  const getNombrePacienteActual = () => {
    if (selectDropDownState?.selectDropDown?.selectGlobal?.pacienteElegido) {
      return camelize(
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.paciente
          .nombre,
      );
    }
    return camelize(authState?.auth?.data?.paciente?.nombre || "");
  };

  return (
    <React.Fragment>
      <div className="ptur-multitabMobileMedicos-container">
        <div className="ptur-multitabMobile-selector">
          <p className="ptur-multitabMobile-texto-viendo">
            Viendo estudios de{" "}
            <button
              className="ptur-multitabMobile-nombre-btn"
              onClick={handleOpenModalFamiliares}
            >
              <span>{getNombrePacienteActual()}</span>
              <IoChevronDown size={16} />
            </button>
          </p>
        </div>
      </div>
      <div className="ptur-multitabMobile-componente-container"></div>
    </React.Fragment>
  );
};

export default MultitabMobileMisMedicos;
